export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/store-login-pic-c258ede5bfb1936954974652e729b18c.png";